import React, { useMemo } from 'react';
import flowRight from 'lodash.flowright';
import { withStyles } from '@material-ui/styles';
import { connect } from 'react-redux';
import { Tooltip } from '@material-ui/core';
import clsx from 'clsx';

import styles from '../styles';
import { translate } from '../../../i18n/I18nProvider';
import withSettings from '../../../utils/withSettings';
import ConnectRangesMoreActionsMenu from './ConnectRangesMoreActionsMenu';

const ConnectRangeActionButtons = ({
  numberRange,
  classes,
  settings,
  connectClientId,
  client
}) => {
  const resetValues = useMemo(() => {
    return {
      id: client,
      getServiceOperator: false,
      getConnectRanges: true,
      connectClientId
    };
  }, [client, connectClientId]);

  return (
    <div className={classes.actionButtons}>
      <ConnectRangesMoreActionsMenu
        numberRange={numberRange}
        resetValues={resetValues}
      >
        <Tooltip title={translate('TOOLTIP.MORE_ACTION')}>
          <i
            className={clsx('fas fa-ellipsis-h', classes.actionIcon)}
            style={{
              color: settings.colors.links
            }}
          ></i>
        </Tooltip>
      </ConnectRangesMoreActionsMenu>
    </div>
  );
};

const mapStatesToProps = ({ selectClient }) => {
  return {
    connectClientId: selectClient.selectedClient.connect30_domain,
    client: selectClient.selectedClient.id
  };
};

export default flowRight(
  withSettings,
  connect(mapStatesToProps),
  withStyles(styles)
)(ConnectRangeActionButtons);
